import { ChartFavouriteModelComponent } from './chart-favourite-model-component';
import { ErrorHandler } from './error-handler';
import { FavouriteLayoutAttributes } from '../../types';
import { DrillDownCallback, CaseViewCallback } from 'app/components/favourite-layout/favourite/common/drill-down-model';

export function createChartFavouriteModelComponent(
  layoutAttributes: FavouriteLayoutAttributes,
  intl: any,
  translation: any,
  errorHandler: ErrorHandler,
  drillDown: DrillDownCallback,
  caseview: CaseViewCallback
): ChartFavouriteModelComponent {
  return new ChartFavouriteModelComponent(
    layoutAttributes, intl, translation, errorHandler, drillDown, caseview);
}
